import { adminPrefix } from "../../constants";

export const homeBannerApis = {
  FETCH_BANNERS: adminPrefix + "home-banners",
  CREATE_BANNER: adminPrefix + "home-banner/create",
  UPDATE_BANNER: adminPrefix + "home-banner/update",
  DELETE_BANNER: adminPrefix + "home-banner/delete",
  UPDATE_BANNER_STATUS: adminPrefix + "home-banner/update-status",
};
